﻿import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Box,
  Tooltip,
} from '@mui/material';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { fetchSignedURL } from '../../../api/file';
import { GetFormsByIDs } from '../../../api/forms';
import { useQuery } from '@tanstack/react-query';

function MarketingFormsTable({ formIDs = '' }) {
  const [formData, setFormData] = useState([]);

  console.log(formIDs);

  const getFormsByIDsQuery = useQuery({
    queryKey: ['formIDs', formIDs],
    queryFn: () => GetFormsByIDs(formIDs)(),
    enabled: formIDs.length > 0,
  });

  useEffect(() => {
    if (getFormsByIDsQuery.data != null) {
      setFormData(getFormsByIDsQuery.data);
    }
  }, [getFormsByIDsQuery.data]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>
        Supporting Materials
      </Typography>

      <TableContainer
        sx={{
          maxHeight: 300,
          overflow: 'auto',
        }}
      >
        <Table stickyHeader>
          <TableBody>
            {formData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  <Typography variant="body2" color="text.secondary" sx={{ py: 4 }}>
                    No forms attached
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              formData.map((row) => (
                <TableRow key={row.ID} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {row.FormName}
                  </TableCell>
                  <TableCell align="right">
                    <Tooltip title="Open Preview" placement="top" arrow>
                      <span
                        className="form-icon-wrapper"
                        onClick={() => {
                          fetchSignedURL(
                            `${process.env.REACT_APP_AGENTPORTAL_PREFIX}/Forms/${row.FileName}`
                          );
                        }}
                        style={{
                          cursor: 'pointer',
                        }}
                      >
                        <OpenInNewIcon />
                      </span>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default MarketingFormsTable;
